import React, { useEffect } from "react";
import { Play } from "lucide-react"; // Play icon
import bingoImg from "../assets/balls-BDjg0rhe.png"; // ← place your image in /src/assets/
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import BingoImg from "../assets/Bingo1.jpg";
import Featured1 from "../assets/aviator.webp";
import Featured2 from "../assets/chicken-road1.PNG";
import Featured3 from "../assets/penality2.avif";
import kenoImg from "../assets/kenologo.jpg";
import { useNavigate } from "react-router-dom";

const games = [
  { name: "Bingo Games", link: "betamountpage", image: BingoImg },
  { name: "Fast Keno", link: "keno-game", image: kenoImg },
];
const featured_games = [
  { name: "AVIATOR", link: "", image: Featured1 },
  { name: "CHICKEN ROAD", link: "", image: Featured2 },
  { name: "PENALTY", link: "", image: Featured3 },
];
export default function HomePage() {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  const navigate = useNavigate();

  const handlePlay = () => {
    navigate("/betamountpage"); // Navigate to bitamount page
  };
  const particleCount = window.innerWidth < 768 ? 25 : 30;
  return (
    <>
      {/* Floating Animation Icons */}
      <div className="particle-container">
        {[...Array(particleCount)].map((_, i) => {
          const type = i % 4; // 4 motion types

          return (
            <div
              key={i}
              className={`particle type-${type}`}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 8}s`,
                animationDuration: `${8 + Math.random() * 10}s`,
              }}
            />
          );
        })}
      </div>

      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-violet-900 via-violet-800 to-violet-900 ">
        {/* <Navbar /> */}
        <Navbar2 />
      </div>
      <div className="min-h-screen bg-primary flex flex-col items-center px-3 py-10 pt-28">
        <div className=" max-w-4xl mx-auto w-full">
          {/* Game Grid */}

          <div className="mb-4">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-2 h-2 bg-cyan-400 rotate-45"></div>
              <h2 className="text-lg font-semibold text-gray-200">
                Habesha Bet
              </h2>
            </div>
            <p className="text-gray-400 text-sm mb-2">
              The best games. The biggest thrills.
            </p>

            <div className="grid grid-cols-2 gap-4">
              {games.map((game) => (
                <div
                  key={game.name}
                  onClick={() => navigate(`/${game.link.toLowerCase()}`)}
                  className="relative group cursor-pointer rounded-xl overflow-hidden border border-cyan-400 bg-[#0f3b63] shadow-[0_0_8px_rgba(34,211,238,0.4)]"
                >
                  {/* Image Section */}
                  <div className="relative">
                    <img
                      src={game.image}
                      alt={game.name}
                      className="w-full h-36 object-cover transition duration-300 group-hover:scale-110"
                    />

                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-white/80 flex items-center justify-center shadow-lg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6 text-gray-800 ml-1"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Title Panel */}
                  <div className="bg-gradient-to-r from-[#0e3e3d] via-[#145b59] to-[#0e3e3d] text-center py-2">
                    <p className="text-white font-semibold text-sm tracking-wide">
                      {game.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="mb-1">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-cyan-400 rotate-45"></div>
              <h2 className="text-lg font-semibold text-gray-200">
                Featured Games
              </h2>
            </div>
            <p className="text-gray-400 text-sm mb-2">
              Feel the excitement of every play.
            </p>

            <div className="grid grid-cols-3 gap-2">
              {featured_games.map((game) => (
                <div
                  key={game.name}
                  onClick={() => navigate(`/${game.link.toLowerCase()}`)}
                  className="relative group cursor-pointer rounded-xl overflow-hidden border border-cyan-400 bg-[#0f3b63] shadow-[0_0_8px_rgba(34,211,238,0.4)]"
                >
                  {/* Image Section */}
                  <div className="relative">
                    <img
                      src={game.image}
                      alt={game.name}
                      className="w-full h-36 object-cover transition duration-300 group-hover:scale-110"
                    />

                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-white/80 flex items-center justify-center shadow-lg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6 text-gray-800 ml-1"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Title Panel */}
                  <div className="bg-gradient-to-r from-cyan-700 via-cyan-600 to-cyan-700 text-center py-2">
                    <p className="text-white font-semibold text-sm tracking-wide">
                      {game.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* ✅ More Games Section */}
          <div className="mt-6 w-full">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 bg-cyan-400 rotate-45"></div>
              <h2 className="text-lg font-semibold text-gray-200">
                Quick Links
              </h2>
            </div>

            {/* Provider Buttons */}
            <div className="flex gap-3 overflow-x-auto no-scrollbar pb-2">
              {[
                { name: "Wallet", link: "wallet", count: 1 },
                { name: "Bingo Games", link: "betamountpage", count: 96 },
                { name: "Fast Keno", link: "keno-game", count: 21 },
              ].map((provider, i) => (
                <button
                  key={i}
                  onClick={() => navigate(`/${provider.link.toLowerCase()}`)}
                  className={`
          flex items-center gap-2
          px-5 py-2
          rounded-full
          whitespace-nowrap
          text-sm font-medium
          transition-all duration-300
          bg-cyan-900/40
          text-gray-200
          border border-cyan-700/40
          hover:bg-cyan-600
        `}
                >
                  {provider.name}
                  <span className="bg-cyan-700 text-xs px-2 py-0.5 rounded-full">
                    {provider.count}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Footer */}
          <div className="mt-16 text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} Play With Habesha Bet
          </div>
        </div>
      </div>

      {/* Animation Styles */}
      <style jsx>{`
        .particle-container {
          position: fixed;
          inset: 0;
          pointer-events: none;
          overflow: hidden;
          z-index: 0;
        }

        .particle {
          position: absolute;
          width: 8px;
          height: 8px;
          background: linear-gradient(135deg, #ffffff, #00ffff, #00bcd4);
          transform: rotate(45deg); /* Diamond Shape */
          box-shadow:
            0 0 6px rgba(0, 255, 255, 0.8),
            0 0 12px rgba(0, 255, 255, 0.4);
          opacity: 0.8;
          filter: drop-shadow(0 0 4px rgba(0, 255, 255, 0.8));
        }

        /* 1️⃣ Top → Bottom */
        .type-0 {
          animation: fallDown linear infinite;
        }

        @keyframes fallDown {
          0% {
            transform: translateY(-10vh) rotate(45deg);
            opacity: 0;
          }
          20% {
            opacity: 1;
          }
          100% {
            transform: translateY(110vh) rotate(45deg);
            opacity: 0;
          }
        }

        /* 2️⃣ Left → Right */
        .type-1 {
          animation: moveRight linear infinite;
        }

        @keyframes moveRight {
          0% {
            transform: translateX(-10vw) rotate(45deg);
            opacity: 0;
          }
          20% {
            opacity: 1;
          }
          100% {
            transform: translateX(110vw) rotate(45deg);
            opacity: 0;
          }
        }

        /* 3️⃣ Top-Left → Bottom-Right */
        .type-2 {
          animation: diagonal1 linear infinite;
        }

        @keyframes diagonal1 {
          0% {
            transform: translate(-10vw, -10vh) rotate(45deg);
            opacity: 0;
          }
          20% {
            opacity: 1;
          }
          100% {
            transform: translate(110vw, 110vh) rotate(45deg);
            opacity: 0;
          }
        }

        /* 4️⃣ Top-Right → Bottom-Left */
        .type-3 {
          animation: diagonal2 linear infinite;
        }

        @keyframes diagonal2 {
          0% {
            transform: translate(10vw, -10vh) rotate(45deg);
            opacity: 0;
          }
          20% {
            opacity: 1;
          }
          100% {
            transform: translate(-110vw, 110vh) rotate(45deg);
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
}
